import React, { Component } from 'react';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import ClientImportTemplateDetails from './clientImportTemplateDetails';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteClientImportTemplate } from '../../../../services/clinicPortalServices/clientImportTemplateService';
import { serviceConstants } from '../../../../services/common/constants';
import { getUserAuthToken, getUserRole, getUserDetails } from '../../../../services/common/util';

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);

        let userName = '';
        if (getUserDetails()) {
            const userDetails = JSON.parse(getUserDetails());
            userName = userDetails.user_name;
        }
        this.state = {
            show: false,
            clientImportTemplateId: props.data._id,
            userName: userName
        };
    }

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this template!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteClientImportTemplate({
                    _id: this.state.clientImportTemplateId,
                    name: this.props.data.name
                }).then((res) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Result Template
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Result Template
        </Tooltip>
    );

    renderTooltipDownload = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Download Template
        </Tooltip>
    );

    handleDownload = () => {
        window.open(
            serviceConstants.API_HOST_NAME +
                '/files/' +
                this.props.data.sourceFileName +
                '?' +
                new Date().getTime() +
                '&token=' +
                getUserAuthToken()
        );
    };

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDownload}>
                    <button onClick={this.handleDownload} className="edit-order-btn">
                        <i className="fas fa-download"></i>
                    </button>
                </OverlayTrigger>
                {getUserRole() &&
                    /^superadmin|^admin/.test(getUserRole().toLowerCase()) &&
                    (this.state.userName === 'creid' ||
                        this.state.userName === 'tai' ||
                        this.state.userName === 'james') && (
                        <OverlayTrigger
                            placement="top"
                            delay={{ show: 50, hide: 100 }}
                            overlay={this.renderTooltipDelete}
                        >
                            <button onClick={this.handleDelete} className="edit-order-btn">
                                <i className="fas fa-trash"></i>
                            </button>
                        </OverlayTrigger>
                    )}
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Result Template Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ClientImportTemplateDetails
                            clientImportTemplateId={this.state.clientImportTemplateId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
